module.exports = __webpack_public_path__ + "img/SK30844754.b8f85014.png";